import * as React from "react";
import PropTypes from "prop-types";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";

class TEdit extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        caption: PropTypes.string,
        name: PropTypes.string,
        value: PropTypes.string,
        type: PropTypes.string,
        onChange: PropTypes.func,
        style: PropTypes.object,
    };

    static defaultProps = {
        caption: "",
        name: "TEdit1",
        value: "",
        type: "",
        onChange: (value) => console.log("onChange [" + value + "]"),
        style: {},
    };

    //==================================================================================================================
    //
    //                                                 Events
    //
    //==================================================================================================================

    onChange = (event) => {
        this.props.onChange(event.target.value);
    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    renderItems = () => {
        const items = [];

        for (let i = 0; i <= this.props.items.length - 1; i++) {
            items.push(
                <MenuItem
                    value={i}
                    key={i}
                >
                    {this.props.items[i]}
                </MenuItem>
            );
        }

        return items;
    };

    render() {
        const selectFieldStyle = {
            //marginTop: 10,
            marginRight: 25,
            paddingLeft: 0,
            //width : '300px',
            marginBottom: 30,
        };

        return (
            <TextField
                id={this.props.name}
                label={this.props.caption}
                value={this.props.value}
                onChange={this.onChange}
                style={{ ...selectFieldStyle, ...this.props.style }}
                type={this.props.type}
            />
        );
    }
}

export default TEdit;
